"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    fields: {
      messages: {
        hideNotesConfirm: 'Jste si jisti, že chcete skrýt poznámku? Přídete o její obsah.'
      },
      actions: {
        addNote: 'Přidat poznámku',
        removeNote: 'Odebrat poznámku',
        unlock: 'Odemknout'
      }
    }
  }
};
var _default = messages;
exports.default = _default;